import React from 'react';
import { Outlet } from 'react-router-dom';
import BtnWhatsapp from '../Components/BtnWhatsapp/BtnWhatsapp';
import Cart from '../Components/Cart/Cart';

export default function PagesLayaut() {
    return (
        <div >
            <Outlet />
            <BtnWhatsapp />
            <Cart />

            <div className='espaciobg2'>

            </div>

        </div>
    );
}
